import React from "react";

export const Prices = ({ data }) => {
  return (
    <div className='pricesServices'>
      <div className='servicesHeader'>
        <span>سرویس</span>
        <span>قیمت</span>
      </div>
      {data.services.map((item) => (
        <div className='services'>
          <span>{item.title}</span>
          <span>{(+item.garage_price).toLocaleString()}{" "}تومان</span>
        </div>
      ))}
    </div>
  );
};
